import {Component, inject} from '@angular/core'
import {RouterOutlet} from '@angular/router'
import {ConfigService} from '@sparbanken-syd/sparbanken-syd-bankid'
import {FooterComponent} from '@sparbanken-syd/sparbanken-syd-theme'
import version from '../assets/package.json'
import {HeaderComponent} from './common/header/header.component'

@Component({
  selector: 'spb-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  imports: [RouterOutlet, FooterComponent, HeaderComponent]
})
export class AppComponent {
  public configService = inject(ConfigService)
  public version = version.version
  public copyrightYears = `2020-${new Date().getFullYear()}`
}
